module.exports = __webpack_public_path__ + "static/img/buttonOne.b6a31372.png";